import { CardFooter, Col } from "reactstrap";
import { FloatingCancleButton, FloatingSubmittButton } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";

export const BasicFloatingFooter = () => {
  return (
    <CardFooter className="text-end">
      <Col sm="9" className="offset-sm-3">
        <Btn color="primary" className="me-3">
          {FloatingSubmittButton}
        </Btn>
        <Btn color="light" type="reset">
          {FloatingCancleButton}
        </Btn>
      </Col>
    </CardFooter>
  );
};
